import React from 'react';

const Card = ({ title, subtitle, action, children, className = '', hoverEffect = false }) => {
  return (
    <div className={`bg-[#121215] border border-[#27272A] rounded-2xl p-4 sm:p-5 shadow-card overflow-hidden ${hoverEffect ? 'transition-all duration-200 hover:border-[#9CA3AF]/40 hover:bg-[#1A1A1E]' : ''} ${className}`}>
      {(title || subtitle || action) && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between pb-3.5 mb-4 border-b border-[#27272A] gap-2">
          <div>
            {title && <h3 className="text-sm font-bold text-[#FFFFFF] tracking-tight truncate">{title}</h3>}
            {subtitle && <p className="text-xs text-[#9CA3AF] mt-0.5">{subtitle}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className="break-words">{children}</div>
    </div>
  );
};

export default Card;
